import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'lib-ksf-side-display',
    templateUrl: './ksf-side-display.component.html',
    styleUrls: ['./ksf-side-display.component.scss'],
    standalone: false
})
export class KsfSideDisplayComponent {
  // Event emitted to the parent component
  @Output() togglePriceIntervalEvent = new EventEmitter();

  // Input properties to receive data from the parent component
  @Input() showYearlyPrice: boolean = false;
  @Input() ksfPrice: number = 0;
  @Input() ksfPriceLoading: boolean = false;
  @Input() ksfPriceResult: any; // make interface

  /**
   * Emits an event to toggle the price interval.
   * @returns void
   */
  togglePriceInterval() {
    this.togglePriceIntervalEvent.emit();
  }
}
